import React, { useContext } from 'react';
import { TabContext } from './Tabs';
import cx from 'clsx';
import styles from './Tabs.module.scss';

export function TabHeader(props: { name: string; children: string }) {
  const { name, children } = props;

  const tabContext = useContext(TabContext);

  const handleClick = () => {
    tabContext.changeTab(name);
  };

  const isActive = tabContext.activeTab === name;

  return (
    <div
      className={cx(styles.tabHeaderWrapper, {
        [styles.tabHeaderActive]: isActive,
      })}
      onClick={handleClick}
      data-testid="tab-header"
    >
      {children}
      {isActive && (
        <div
          className={styles.selectionElement}
          data-testid="selection-element"
        />
      )}
    </div>
  );
}
